export default defineNuxtPlugin((nuxtApp) => {
    const { sessionSiteLocale } = useSessionSiteLocale();

    nuxtApp.hook('i18n:localeSwitched' as any, (newLocale: string) => {
        // Assert the type of sessionSiteLocale to accept strings
        (sessionSiteLocale as unknown as Ref<string | null>).value = newLocale;
    });
});
